import { CampaignStatusEnum } from "schema"

export const STATUSES_FOR_SHEET_ENABLED = [CampaignStatusEnum.Draft, CampaignStatusEnum.Paused]
